"use client"

import { Church } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChurchIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChurchIcon = component(Icon)({ as: Church })
